(window as any).global = window;
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';


import { initializeApp, getApps } from 'firebase/app';
const firebaseConfig = {
  apiKey: "AIzaSyC0dnfywlm2gfKMNBkx7eAZrxGucNKR82A",
  authDomain: "astroapp-44f62.firebaseapp.com",
  projectId: "astroapp-44f62",
  storageBucket: "astroapp-44f62.appspot.com",
  messagingSenderId: "711485441025",
  appId: "1:711485441025:web:88bf8f16fad76624752c00",
  measurementId: "G-CGY4J3XVL8",
  vapidKey: "BFJqjJ24zXYZfy9MrtaBem-MpHFabekNzy8WXQKwSU9lLbRx4R160xX3m-FWBcDfiUqbjX8AgYcskbFDPg0Kurg"
};


if (!getApps().length) {
  initializeApp(firebaseConfig);
}


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
